/**
 * LocationVenueSetupService
 * Service for LocationVenueSetup entity operations
 * Route: api/locationvenuesetups
 * Controller: LocationVenueSetupsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * LocationVenueSetupService
 * Handles location venue setup CRUD operations
 * Maps to /api/locationvenuesetups endpoint
 */
export class LocationVenueSetupService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LocationVenueSetupService.DEFAULT_SERVICE_PATH,
            basePath: LocationVenueSetupService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LocationVenueSetupService.DEFAULT_SERVICE_PATH = 'meetings';
LocationVenueSetupService.BASE_PATH = 'api/locationvenuesetups';
//# sourceMappingURL=LocationVenueSetupService.js.map